import React, {useEffect, useState} from 'react'
import localization from "../../../assets/localization/localization";
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import FormSection from "../../../components/sales/formSection/formSectionNew";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import Checkbox from "components/sales/Input/checkbox/checkbox";

const ContractServices = ({
                              serviceDetails = [],
                              setVariableServices = () => {},
                              setFixedServices = () => {},
                              handleVariableService = () => {},
                              handleFixedService = () => {},
                              variableServices,
                              fixedServices,
                              revenueNature,
                              managementFeeApplicable,
                              handleValue = () => {},
                              commercialData=[],
                          }) => {

    const days = [
        {id:1, name:"Monday"},
        {id:2, name:"Tuesday"},
        {id:3, name:"Wednesday"},
        {id:4, name:"Thursday"},
        {id:5, name:"Friday"},
        {id:6, name:"Saturday"},
        {id:7, name:"Sunday"},
    ];

    const daysForPrint = [
        "",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ]
    const [isServiceFixed, setIsServiceFixed] = useState(false)
    const handleAddVariableServices = () => {
        setVariableServices([
            ...variableServices, {id:'', amount:'', qty:'', men_days:0, start_day:'', end_day:''}
        ])
    }

    const handleRemoveVariableServices = (key) => {
        let list = [...variableServices]
        list.splice(key, 1)
        setVariableServices(list)
    }

    const handleAddFixedServices = () => {
        setFixedServices([
            ...fixedServices, {id:'', amount:'', qty:'', men_days:0}
        ])
    }

    const handleRemoveFixedServices = (key) => {
        let list = [...fixedServices]
        list.splice(key, 1)
        setFixedServices(list)
    }


    useEffect(() => {
        setIsServiceFixed(false)
          if(variableServices[0]['id'] === '' && fixedServices[0]['id'] !== ''){
              setIsServiceFixed(true)
              handleValue('invoice_type', commercialData?.invoice_type)
          }else{
              handleValue('invoice_type', 'Post')
          }
    }, [variableServices, fixedServices])


    useEffect(() => {
        if (commercialData?.invoice_type !== undefined &&
            commercialData?.invoice_type !== null &&
            commercialData?.invoice_type !== '') {
            handleValue('invoice_type', commercialData?.invoice_type)
        }
    }, [commercialData])

    return (
        <>
            <FormSection title={localization.variableServices}>
                {variableServices.map((val, i) => {
                    return (
                        <div className='' key={i}>
                            <div className="col-12">
                                <DropDownInput
                                    data={serviceDetails['V'] ?? []}
                                    label={localization.enterService}
                                    // required
                                    // isStarRequired={true}
                                    errorMsg={localization.requiredServices}
                                    getIdValue={(val) => {handleVariableService(i, 'id', val?.id)}}
                                    value={val?.name}
                                />
                            </div>
                            
                            <div className="col-12">
                                <ConstantInput
                                    label={localization.unitPrice}
                                    errorMsg={localization.amountRequired}
                                    // required
                                    // isStarRequired={true}
                                    type="number"
                                    value={val?.amount}
                                    handleChange={(val) => {handleVariableService(i, 'amount', val)}}
                                />
                            </div>

                            <div className="col-12">
                                <ConstantInput
                                    label={localization.quantity}
                                    errorMsg={localization.qtyRequired}
                                    // required
                                    // isStarRequired={true}
                                    type="number"
                                    value={val?.qty}
                                    handleChange={(val) => {handleVariableService(i, 'qty', val)}}
                                />
                            </div>
                            {revenueNature && revenueNature.length > 0 && revenueNature[0] == "Services" && managementFeeApplicable?.is_applicable && 
                                <div className="col-12">
                                    <Checkbox
                                        label={localization.managementFeeApplicable}
                                        type="checkbox"
                                        errorMsg={localization.isRequired}
                                        noWrap={true}
                                        onChange={val => {handleVariableService(i, 'management_fee_applicable', val == true?1:0)}}
                                    />
                                </div>
                            }

                           


                            <div className="btn-box mb-4" style={{"width": "100%"}}>
                                {variableServices.length !== 1 &&
                                    <>
                                        <button
                                            onClick={() => handleRemoveVariableServices(i)}
                                            className="btn btn-sm btn-danger mr10">Remove
                                        </button>
                                    </>
                                }
                                {variableServices.length - 1 === i &&
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => handleAddVariableServices()}>Add
                                    </button>}
                            </div>
                        </div>
                    )
                })}
            </FormSection>

            <FormSection title={localization.fixedServices}>
                {fixedServices.map((val, i) => {
                    return (
                        <>
                            <div className="col-12">
                                <DropDownInput
                                    data={serviceDetails['F'] ?? []}
                                    label={localization.enterService}
                                    // required
                                    // isStarRequired={true}
                                    errorMsg={localization.requiredServices}
                                    getIdValue={(val) => {handleFixedService(i, 'id', val?.id)}}
                                    value={val?.name}
                                />
                            </div>
                            <div className="col-12">
                                <ConstantInput
                                    label={localization.unitPrice}
                                    errorMsg={localization.amountRequired}
                                    // required
                                    // isStarRequired={true}
                                    type="number"
                                    value={val?.amount}
                                    handleChange={(val) => {handleFixedService(i, 'amount', val)}}
                                />
                            </div>

                            <div className="col-12">
                                <ConstantInput
                                    label={localization.quantity}
                                    errorMsg={localization.qtyRequired}
                                    // required
                                    // isStarRequired={true}
                                    type="number"
                                    value={val?.qty}
                                    handleChange={(val) => {handleFixedService(i, 'qty', val)}}
                                />
                            </div>
                            {revenueNature && revenueNature.length > 0 && revenueNature[0] == "Services" && managementFeeApplicable?.is_applicable && 
                                <div className="col-12">
                                    <Checkbox
                                        label={localization.managementFeeApplicable}
                                        type="checkbox"
                                        errorMsg={localization.isRequired}
                                        noWrap={true}
                                        onChange={val => {handleFixedService(i, 'management_fee_applicable', val == true?1:0)}}
                                    />
                                </div>
                            }


                            {/*<div className="col-12">*/}
                            {/*    <ConstantInput*/}
                            {/*        label={localization.menDays}*/}
                            {/*        errorMsg={localization.menDaysRequired}*/}
                            {/*        required*/}
                            {/*        isStarRequired={true}*/}
                            {/*        type="number"*/}
                            {/*        value={val?.men_days}*/}
                            {/*        handleChange={(val) => {handleFixedService(i, 'men_days', val)}}*/}
                            {/*    />*/}
                            {/*</div>*/}


                            <div className="btn-box mb-4" style={{"width": "100%"}}>
                                {fixedServices.length !== 1 &&
                                    <>
                                        <button
                                            onClick={() => handleRemoveFixedServices(i)}
                                            className="btn btn-sm btn-danger mr10">Remove
                                        </button>
                                    </>
                                }
                                {fixedServices.length - 1 === i &&
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => handleAddFixedServices()}>Add
                                    </button>}
                            </div>
                        </>
                    )
                })}
                {isServiceFixed &&
                    <div className="col-12">
                        <DropDownInput
                            data={[{id:'Pre', name:"Pre"}, {id:'Post', name: 'Post'}]}
                            label={localization.revenueInvoiceType}
                            required
                            isStarRequired={true}
                            errorMsg={localization.requiredRevenueInvoice}
                            getIdValue={(val) => {handleValue('invoice_type', val?.id)}}
                            value={commercialData?.invoice_type  ?? 'Post'}
                        />
                    </div>
                }
            </FormSection>
        </>
    )
}

export default ContractServices